import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import IconIdReverseWhite from '../../assets/icon-id-reverse-white.svg';
import IconSignWhite from '../../assets/icon-sign-white.svg';

// import useLoadScriptsMitekSDK from '../../hooks/useLoadScriptsMitekSDK';
import useMitekSDK from '../../hooks/useMitekSDK';
import { setIsLoading } from '../../app/store/majesticSlice';
import { setImageSide } from '../../app/store/ocrSlice';
import usePageNavigation from '../../hooks/usePageNavigation';
// import { startCaptureProcess, processStop } from '../../utils/handleMitekSDK';

function GuestDocumentReverseCapturePage() {
  const {
    documentType,
    imageSide,
  } = useSelector((state) => state.ocr);
  const [backgrounImage, setBackgroundImage] = useState({});

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasScanner = useRef(false); // Usamos un ref para controlar la ejecucion
  // TODO: usar una promesa para lazar startCaptureProcess asincronicamente
  // useLoadScriptsMitekSDK();

  const { navigateNextPage } = usePageNavigation();

  const {
    startCaptureProcess,
    processStop,
    captureSuccess,
    imageData,
    txtFeedBack,
  } = useMitekSDK();

  const stableStartCapture = useCallback(startCaptureProcess, []);
  const stableProcessStop = useCallback(processStop, []);

  useEffect(() => {
    document.body.style.backgroundColor = 'black';
    dispatch(setIsLoading(true));

    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Hace el scroll animado
    });

    if (hasScanner.current) {
      // Si ya se ejecuto, no hagas nada y devuelve una funcion de limpieza vacia
      return () => {
        stableProcessStop();
        setBackgroundImage({});
        document.body.style.backgroundColor = '';
      };
    }

    hasScanner.current = true;

    stableStartCapture();

    return () => {
      if (process.env.NODE_ENV !== 'development') {
        stableProcessStop();
      }
      setBackgroundImage({});
      document.body.style.backgroundColor = '';
    };
  }, [dispatch, stableStartCapture, stableProcessStop]);

  useEffect(() => {
    if (captureSuccess && imageData !== '') {
      setBackgroundImage({
        background: `url(${imageData})`,
        backgroundPosition: 'center',
        backgroundOrigin: 'content-box',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      });

      dispatch(setImageSide({ imageSide: 'imageReverse', imageData }));
      setTimeout(() => {
        // navigate('/DocumentPreview');
        navigateNextPage('DocumentPreview');
      }, 1500);
    }
  }, [dispatch, navigateNextPage, imageData, captureSuccess]);

  return (
    <div className="guest__document-capture">
      <div className="dc__type my-5 text-center">
        <p className=" mb-0 text-white app-fw-segoe-bold app-fs-22">{t(`TXT_${documentType}`)}</p>
        <p className="mb-0 text-white app-fw-segoe-bold">{t('TXT_IMAGE_SIDE_REVERSE')}</p>

        <div>
          <img src={documentType === 'INE' ? IconIdReverseWhite : IconSignWhite} alt={documentType} className="my-2" />
        </div>

        <p className="mb-0 text-warning app-fw-segoe-bold">{t(txtFeedBack)}</p>
      </div>

      <div className="dc__picture text-center">
        <div className="dc__guidebox-camera position-relative mx-auto" style={backgrounImage}>
          <div id="mitek-content-video" />
          <div className={`dc__success ${captureSuccess ? 'd-block' : 'd-none'}`}>
            {/* <img style={{ height: '225px' }} src={picture} alt="" /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuestDocumentReverseCapturePage;
